import React from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Rating } from '@thd-olt-component-react/rating';
import classNames from 'classnames';
import { usePresentation } from '../../../../context/PresentationProvider';

export const AttributeRatings = ({ ratings, dispatch }) => {
  const { useCondensedLayout } = usePresentation();

  const getRatingLabel = (rating) => {
    switch (rating.value) {
      case 1:
        return 'Poor';
      case 2:
        return 'Fair';
      case 3:
        return 'Average';
      case 4:
        return 'Good';
      case 5:
        return 'Excellent';
      default:
        return '';
    }
  };

  return (
    <div className="attribute-ratings">
      {
        ratings.map((rating, index) => {
        const { name } = rating;
        const attributeClassNames = classNames('attribute-ratings__attribute', {
          'attribute-ratings__attribute--align-text': name === 'Overall'
        });
        const ratingClassNames = classNames('attribute-ratings__rating', {
          'attribute-ratings__rating--mobile': useCondensedLayout
        });
        return (
          <div key={`${name}-${index}`} className="attribute-ratings__attribute">
            <Row>
              <Col fallback="3" xs="3" className={attributeClassNames}>
                <span className="attribute-ratings__rating">{name}:</span>
              </Col>
              <Col fallback="3" xs="3" className={attributeClassNames}>
                <span className="write-review-content__attributes__rating write-review-content__attributes__rating__value">{getRatingLabel(rating)}</span>
              </Col>
              <Col fallback="6" xs="6" className={ratingClassNames}>
                <Rating
                  interactive
                  onClick={(value) => dispatch({ rating, value })}
                  orange
                  sectionClassName={name !== 'Overall' ? 'dashed' : null}
                  type={name === 'Overall' ? 'stars' : 'dash'}
                  />
              </Col>
            </Row>
          </div>
        );
      })
      }
    </div>
  );

};
